import { Box } from '@mui/material';
import React from 'react';
import TagManager from '@sooro-io/react-gtm-module';
import MetaTags from '../../components/MetaTags';
import Footer from '../../components/layout/Footer';
import Header from '../../components/layout/Header';
import TopBar from '../../components/layout/TopBar';
import Intro from '../../components/services/Intro';
import ServicesBody from '../../components/services/ServicesBody';
import ServicesOverview from '../../components/services/CoreService';
TagManager.dataLayer({
  dataLayer: {
    event: 'pageview',
    pagePath: '/services',
    pageTitle: 'Services',
  },
});
const Services = () => {
  const [scrollValue, setScrollValue] = React.useState(0);
  React.useEffect(() => {
    const onScroll = (e: Event) => {
      setScrollValue((e.target as Document).documentElement.scrollTop);
    };

    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <Box sx={{ position: 'relative' }}>
      <MetaTags
        title="A&E Financial Services - Services. Read | taxes | processes"
        description="Discover A&E Financial Services, your trusted source for personalized insurance, read taxes, and financial solutions, including expert tax services and efficient processes, catering to your various insurance needs 24/7."
        keywords="Income tax in Houston,Income tax preparation in Houston,Tax office near Stafford,Tax office near 77036,Tax office near 77082,Tax office near 77099,Tax office near 77007,Tax office near 77479,Tax office near 77401,Tax office near 77489, Taxes, Financial, Financial Services, read, processes"
        url="https://www.aefinancialservicesllc.com"
        imageUrl="https://imageupload.io/ib/9NZbCa0NJGHTFJJ_1699552355.png"
      />
      {scrollValue < 100 && <TopBar />}
      {scrollValue < 200 ? <Header headerType="absolute" /> : <Header />}
      <Intro />
      <ServicesOverview />
      <ServicesBody />
      <Footer />
    </Box>
  );
};

export default Services;
